type JSONCSVValue = {
  col_name: string;
  value: string;
};

type CSVValue = {
  colName: string;
  value: string;
};

function fromJSON(jsonCSV: JSONCSVValue): CSVValue {
  return {
    colName: jsonCSV.col_name,
    value: jsonCSV.value,
  };
}

export default CSVValue;

export { fromJSON, JSONCSVValue };
